import css from './index.module.scss';
import A from './components/A';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';

export default function SaveElectricPC() {
    return (
        <div className={`save-electric ${css.SaveElectric}`}>
            <A />
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
        </div>
    );
}
